// @flow

type Mode = 'Legacy' | 'WYSIWYG'

const linkifyCustomProtocols = (source: string, mode: Mode = 'Legacy'): string => {
  const specialLinkPattern = new RegExp(['(',
    /href=["']|["']>\s*?/.source, '|', // matches link tag
    /\[[\S ]*?]\(/.source, ')', // matches markdown links
  ].join(''), 'g')

  const urlPattern = new RegExp([
    /(ftp|ms-\w+|https?):\/\//.source, // protocol
    /(?:www\.)?/.source, // www
    /[-a-zA-Z0-9@:%._+~#=]{2,256}/.source, // domain
    /[a-z]{2,6}/.source, // top level domain
    /[-a-zA-Z0-9@:%_+.~#?&/=]*/.source, // query
  ].join(''), 'g')

  // The strategy here is to match special links in the left side of or (`|`) beforehand
  // and then if url is part of link, there would be 2 group matches, otherwise only 1
  const pattern = new RegExp([
    specialLinkPattern.source,
    urlPattern.source, '|',
    '(', urlPattern.source, ')',
  ].join(''), 'g')

  const linkify = (link: string) => (mode === 'Legacy'
    ? `<a target="_blank" rel="noopener noreferrer" href="${link}">${link}</a>`
    : `[${link}](${link})`)

  return source.replace(pattern, (g1, g2) => (typeof g2 === 'undefined' ? linkify(g1) : g1))
}

export default linkifyCustomProtocols
